import axios from '@/utils/request';
const prefix = process.env.VUE_APP_API_PREFIX_1;
const baseOriginURL = prefix + '/customer';

// 获取客户列表
const GetCustomerList = params => {
  return axios.get(`${baseOriginURL}/GetCustomerList`, {
    params
  });
};

// 新增客户
const CreateCustomer = data => {
  return axios.post(`${baseOriginURL}/CreateCustomer`, data);
};

// 修改客户
const UpdateCustomer = data => {
  return axios.put(`${baseOriginURL}/UpdateCustomer`, data);
};

// 删除客户
const DeleteCustomer = data => {
  return axios.delete(`${baseOriginURL}/DeleteCustomer`, data);
};

// 修改客户状态
const UpdateCustomerStatus = data => {
  return axios.put(`${baseOriginURL}/UpdateCustomerStatus`, data);
};

// 重置客户密码
const ResetPassword = data => {
  return axios.put(`${baseOriginURL}/ResetPassword`, data);
};

// 获取客户详情
const GetCustomerInfo = params => {
  return axios.get(`${baseOriginURL}/GetCustomerInfo`, {
    params
  });
};

// 获取客户管理统计数据
const GetCustomerManageOverview = params => {
  return axios.get(`${baseOriginURL}/GetCustomerManageOverview`, {
    params
  });
};

// 客户总览
const GetCustomerOverview = params => {
  return axios.get(`${baseOriginURL}/GetCustomerOverview`, {
    params
  });
};

// 获取组织树
const GetOrgTree = params => {
  return axios.get(`${baseOriginURL}/GetOrgTree`, {
    params
  });
};

// 获取行业树形
const GetIndustryTree = params => {
  return axios.get(`${baseOriginURL}/GetIndustryTree`, {
    params
  });
};

// 获取客户短信总数和已使用数量
const GetCustomerSmsInfo = params => {
  return axios.get(`${baseOriginURL}/GetCustomerSmsInfo`, {
    params
  });
};

export {
  GetCustomerList,
  CreateCustomer,
  UpdateCustomer,
  DeleteCustomer,
  UpdateCustomerStatus,
  ResetPassword,
  GetCustomerInfo,
  GetCustomerManageOverview,
  GetCustomerOverview,
  GetOrgTree,
  GetIndustryTree,
  GetCustomerSmsInfo,
};
